// extracted by mini-css-extract-plugin
export default {"root":"MenuItem_root__y-Amd","menuItemImage":"MenuItem_menuItemImage__SU-oE"};